import React from "react";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/vineyard_wind_vines.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/vineyard_wind_vines.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/vineyard_wind_vines.png-wvc-sizes",
  alt: "Soft wind blowing through the lush green vines at sunset"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/wine_pouring_glass.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/wine_pouring_glass.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/wine_pouring_glass.png-wvc-sizes",
  alt: "Deep red wine being poured into a crystal glass"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/candlelit_cellar_barrels.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/candlelit_cellar_barrels.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/candlelit_cellar_barrels.png-wvc-sizes",
  alt: "Oak barrels resting in our quiet candlelit cellar"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/harvest_celebration_gathering.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/harvest_celebration_gathering.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/harvest_celebration_gathering.png-wvc-sizes",
  alt: "Local community gathering for the annual harvest celebration"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/estate_morning_mist.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/estate_morning_mist.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/estate_morning_mist.png-wvc-sizes",
  alt: "Morning mist rolling over the Velvet Vineyards estate"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/tasting_room_details.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/tasting_room_details.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/tasting_room_details.png-wvc-sizes",
  alt: "Elegant table setting in our private tasting room"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/winemaker_hands_soil.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/winemaker_hands_soil.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/winemaker_hands_soil.png-wvc-sizes",
  alt: "The winemaker examining the rich estate soil"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/cork_pull_moment.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/cork_pull_moment.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/cork_pull_moment.png-wvc-sizes",
  alt: "The precise moment a vintage bottle is opened"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/sunset_over_rows.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/sunset_over_rows.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/sunset_over_rows.png-wvc-sizes",
  alt: "Golden hour light stretching across the vineyard rows"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/velvet_vineyards_sign.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/velvet_vineyards_sign.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/velvet_vineyards_sign.png-wvc-sizes",
  alt: "The hand-carved entrance sign of Velvet Vineyards"
}];
export default function VineyardVistas() {
  return <section data-section-id="258951" id="vineyard-vistas" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6">
          {galleryImages.map((image, index) => <div key={index} data-index={index} className="break-inside-avoid mb-4 md:mb-6 relative group overflow-hidden rounded-md border border-border shadow-sm">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="w-full h-auto object-cover transition-transform duration-1000 ease-in-out group-hover:scale-105" />
              {}
              <div className="absolute bottom-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                <p className="text-xs italic font-serif text-primary-foreground bg-primary/40 backdrop-blur-sm px-2 py-1 rounded-sm">
                  {image.alt}
                </p>
              </div>
              <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/5 transition-colors duration-700 pointer-events-none" />
            </div>)}
        </div>
      </div>
    </section>;
}